import { FETCH_PROJECT_PACKAGES } from '#action/types';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_PACKAGES:
      return { ...state, [action.id]: action.payload };
    default:
      return state;
  }
};
